// Depends on product handles for VOLT and BLADE and their parts

(function setupCartForBundles() {
  window.HS_SLIDE_CART_LOADED = (cart) => setTimeout(() => handleUpdated(cart), 1);
  window.HS_SLIDE_CART_UPDATED = (cart) => setTimeout(() => handleUpdated(cart), 1);

  function getMap(cart) {
    const bundleItems = cart.items.filter(
      (item) => item.properties._customizable_group_id
    );
    const bundlesMap = bundleItems
      .map((item) => item.properties._customizable_group_id)
      .reduce(
        (acc, id) => ({
          ...acc,
          [id]: { items: [], totalPrice: 0, variantTitles: [] },
        }),
        {}
      );
    for (const item of bundleItems) {
      const value = bundlesMap[item.properties._customizable_group_id];
      value.items.push(item);
      value.totalPrice += item.line_price;
      value.variantTitles.push(item.variant_title);
      if (item.handle.includes("volt")) {
        value.productTitle = "The VOLT";
        value.productHandle = "the-volt";
      } else if (item.handle.includes("blade")) {
        value.productTitle = "The BLADE";
        value.productHandle = "the-blade";
      }
    }

    return bundlesMap;
  }

  function validateMarkup() {
    const itemEl = document.querySelector('.hs-item-cart-content')
    if (!itemEl) throw new Error("Unable to mutate cart (1)")
    if (
      !itemEl.querySelector(".hs-product-title") ||
      !itemEl.querySelector(".hs-variant-title") ||
      !itemEl.querySelector(".hs-item-cart-content-quantity") ||
      !itemEl.querySelector(".hs-content-quantity-price") ||
      !itemEl.querySelector(".hs-price-total") ||
      !itemEl.querySelector(".hs-item-close") ||
      !itemEl.querySelector(".hs-item-cart-image-content") ||
      !itemEl.querySelector(".hs-item-cart-image")
     ) throw new Error("Unable to mutate cart (2)")
  }

  function handleUpdated(cart) {
    validateMarkup()
    const bundlesMap = getMap(cart);

    let parentEl;

    for (const [
      bundleId,
      { items, productTitle, totalPrice, variantTitles, productHandle },
    ] of Object.entries(bundlesMap)) {
      const keysStr = items
        .map((item) => item.key)
        .join(",");

      let newItemEl;
      for (const item of items) {
        const itemEl = document.querySelector(
          `.hs-item-cart-content[data-item-key="${item.key}"]`
        );

        if (!itemEl) {
          continue;
        }

        if (!newItemEl) {
          newItemEl = itemEl.cloneNode(true);
          parentEl = itemEl.parentElement;
        }

        itemEl.remove();
      }

    
      newItemEl.removeAttribute("data-item-key");
      newItemEl.querySelector(".hs-product-title").innerText = productTitle;
      newItemEl.querySelector(".hs-variant-title").innerHTML =
        variantTitles.join("</br>");
      newItemEl.querySelector(".hs-item-cart-content-quantity").remove();
      newItemEl.querySelector(".hs-content-quantity-price").style =
        "justify-content: end;";
      newItemEl.querySelector(".hs-price-total").innerHTML =
        hsonslidecart.Currency.formatMoney(
          totalPrice,
          window.HSSLIDECART.setSettings.settings.devices.money_format
        );
      newItemEl
        .querySelector(".hs-price-total")
        .classList.remove("hs-discount-price-line-through");
      newItemEl.querySelector(".hs-discount-price-total")?.remove();
      newItemEl.querySelector(".hs-discount-promo")?.remove();
      newItemEl
        .querySelectorAll("a")
        .forEach(
          (a) => (a.href = `${Shopify.routes.root}products/${productHandle}`)
        );
      newItemEl.querySelector(".hs-item-close").dataset.keysStr = keysStr
      newItemEl.dataset.keysStr = keysStr
      newItemEl
        .querySelector(".hs-item-close")
        .addEventListener("click", handleRemove);

      Promise.all(
        items.map(async (item) => {
          const res = await fetch(
            `/products/${item.handle}?variant=${item.variant_id}&section_id=bundles-cart-override-helper`
          );
          const text = await res.text();
          const innerHtml = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".shopify-section").innerHTML;
          return innerHtml;
        })
      ).then(imagesHtml => {
        newItemEl.querySelector(".hs-item-cart-image-content").style =
          "display: none;";
        newItemEl.querySelector(".hs-item-cart-image-content").innerHTML =
          imagesHtml.reverse().join("");
        newItemEl.querySelector(".hs-item-cart-image").style =
          "position: relative;";
        newItemEl
          .querySelectorAll(".hs-item-cart-image-content img")
          .forEach(
            (img) =>
              (img.style =
                "position: absolute;top: 0; left: 0; width: 70px!important; height: 70px!important;")
          );
        newItemEl.querySelector(".hs-item-cart-image-content").style =
          "display: block;";
      })
      parentEl.appendChild(newItemEl);

    }
  }

  async function handleRemove(e) {
    const keys = e.currentTarget.dataset.keysStr.split(",");
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: keys.reduce((a, b) => ({ ...a, [b]: 0 }), {}),
      }),
    });
    window.HS_SLIDE_CART_UPDATE();
  }
})();
